import { render, staticRenderFns } from "./Products.vue?vue&type=template&id=790bbdc6&scoped=true&"
import script from "./Products.vue?vue&type=script&lang=ts&"
export * from "./Products.vue?vue&type=script&lang=ts&"
import style0 from "./Products.vue?vue&type=style&index=0&id=790bbdc6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "790bbdc6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1771009219/src/capas-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('790bbdc6')) {
      api.createRecord('790bbdc6', component.options)
    } else {
      api.reload('790bbdc6', component.options)
    }
    module.hot.accept("./Products.vue?vue&type=template&id=790bbdc6&scoped=true&", function () {
      api.rerender('790bbdc6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Brand/Products.vue"
export default component.exports